import React, { useContext } from "react";
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import ListIcon from '@mui/icons-material/List';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import UserContext from "Context/UserProvider";
import { useNavigate } from "react-router";
import DashboardCard from '../common/DashboardCard';

function UserManagement(props: any) {
    const dashboardInfo = props.dashboardInfo;
    const { userInfo } = useContext(UserContext);
    const navigate = useNavigate();

    return (
        <DashboardCard
            title="User Management"
            icon={<GroupIcon />}
        >
            <List>
                <ListItemButton
                    onClick={() => {
                        navigate("/common/user/list", {
                            state: {
                                fleetScenarioUuid: dashboardInfo?.lastDraftScenario?.uuid,
                            },
                        });
                    }}
                >
                    <ListItemIcon>
                        <ListIcon />
                    </ListItemIcon>
                    <ListItemText primary="List Users" />
                </ListItemButton>
                <ListItemButton
                    onClick={() => {
                        navigate("/common/user/add", {
                            state: {
                                optionCategory: [true, false],
                                business: {
                                    name: userInfo.businessName,
                                    uuid: userInfo.businessUuid,
                                },
                            },
                        });
                    }}
                >
                    <ListItemIcon>
                        <PersonAddIcon />
                    </ListItemIcon>
                    <ListItemText primary="Add User" />
                </ListItemButton>
            </List>
        </DashboardCard>
    );
}

export default UserManagement;
